export default __webpack_public_path__ + "locales/hy-AM/DeleteProfileEverDialog.json?hash=b46ce7bf953cc6043f3bdb39a2352fc4";